export default {"src":"/_next/static/media/cream.7bc845dd.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};